import styled from 'styled-components';

export const StyledContainer = styled.ul`
  display: flex;
  margin-bottom: 40px;
`;
